<template>
	<div>
		
			<navigation msg="新闻咨询" />
			<router-view></router-view>
	</div>
</template>

<script>
	import navigation from '@/components/comm/navigation.vue'
	export default{
		data(){
			return {}
		},
		components:{
			navigation
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/jm/admin/xinwenzixun/home.vue